<label class="ui-label ui-label--md">Ingresa los datos de tu tarjeta</label>
<ngx-stripe-card-group [elementsOptions]="elementsOptions">
  <ngx-stripe-card-number [options]="cardOptions" />
  <div class="second-line">
    <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
    <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
  </div>
</ngx-stripe-card-group>
@if (error) {
  <pxw-alert type="danger" class="error">{{ error }}</pxw-alert>
}
